module.exports = __webpack_public_path__ + "static/home2-b3aebd55250d403f8f29d8a7ecddf6b3.png";